import {
  formatReviews,
  trustpilotHumanScore,
} from "@/components/trustpilot/ultis/trustpilotReviewHelpers";

import TrustpilotLogo from "./TrustpilotLogo";
import TrustpilotStars from "./TrustpilotStars";
import styles from "./TrustpilotSummary.module.css";
import { useTrustpilotBusinessUnitQuery } from "./api/useTrustpilotBusinessUnitQuery";

function TrustpilotSummary() {
  const { businessUnit, isLoadingBusinessUnit } =
    useTrustpilotBusinessUnitQuery();

  if (isLoadingBusinessUnit || !businessUnit) return null;

  const trustScore = businessUnit.trustScore;
  const totalReviews = businessUnit.numberOfReviews;
  const humanScore = trustpilotHumanScore(trustScore);
  const trustpilotAriaLabel =
    "Trustpilot reviews. Rated " +
    humanScore +
    ". " +
    trustScore +
    " out of 5. Based on " +
    formatReviews(totalReviews) +
    " reviews on Trustpilot. Click to view Trustpilot profile.";

  return (
    <section className={styles.trustpilotSummaryWrapper}>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={businessUnit.profileUrl}
        aria-label={trustpilotAriaLabel}
        className={styles.header}
      >
        <div className={styles.widgetHumanScore}>
          <span className={styles.trustScore}>{humanScore}</span>
        </div>

        <div className={styles.widgetStars}>
          <TrustpilotStars rating={trustScore} size={25.85} />
        </div>
        <div>
          <div className={styles.widgetBusinessInfo}>
            <span>
              Rated <b>{trustScore} / 5</b> based on{" "}
              <strong className={styles.totalReviews}>
                {formatReviews(totalReviews)} reviews
              </strong>{" "}
              on{" "}
            </span>
          </div>

          <div className={styles.widgetLogo}>
            <TrustpilotLogo />
          </div>
        </div>
      </a>
    </section>
  );
}

export default TrustpilotSummary;
